// Umami Analytics — lightweight, privacy-friendly, cookieless visitor
// analytics. Gives visitor counts, top countries/regions/cities (geolocated
// from IP server-side, no IP stored), devices, and referrers in the Umami
// dashboard. Self-hostable on your existing PostgreSQL with a tiny footprint.
//
// Opt-in via env, mirroring src/sentry.js: with no VITE_UMAMI_WEBSITE_ID /
// VITE_UMAMI_SRC set (local dev, contributor builds) nothing is loaded and no
// network calls fire.

const websiteId = import.meta.env.VITE_UMAMI_WEBSITE_ID;
const src = import.meta.env.VITE_UMAMI_SRC;

if (websiteId && src) {
  // Umami's script auto-tracks SPA navigations via the History API, so
  // react-router route changes are counted without any per-route code.
  const script = document.createElement('script');
  script.defer = true;
  script.src = src;
  script.setAttribute('data-website-id', websiteId);
  document.head.appendChild(script);
}
